import React from 'react';
import { inject, observer } from 'mobx-react';

import {
  Table,
  Th,
  Tr,
  Td,
  StyledLink,
} from '@components/TracksHistory/TableView/style';
import dayjs from 'dayjs';
import routes from '@routes';

const TableView = ({ tracksHistoryStore: { trackHistories } }) => {
  return (
    <Table>
      <thead>
        <tr>
          <Th>&nbsp;</Th>
          <Th>Date</Th>
          <Th>Album</Th>
          <Th>Track number</Th>
          <Th>Track</Th>
          <Th>Change</Th>
          <Th>&nbsp;</Th>
        </tr>
      </thead>
      <tbody>
        {trackHistories.map((item, index) => (
          <Tr key={`history-table-row_${item?.track.id}_${index}`}>
            <Td>&nbsp;</Td>
            <Td> {dayjs(item.created_at).format('DD.M.YYYY')}</Td>
            <Td>
              <StyledLink to={routes.album(item.track.album_uuid)}>
                {item.track?.album?.name}
              </StyledLink>
            </Td>
            <Td>{item.track?.number}</Td>
            <Td>{item.track?.name}</Td>
            <Td>{item.changes_text}</Td>
            <Td>&nbsp;</Td>
          </Tr>
        ))}
      </tbody>
    </Table>
  );
};

export default inject('tracksHistoryStore')(observer(TableView));
